import React from "react";
import { graphql, StaticQuery } from "gatsby";

export default function OpenDayList () {

    return (
        <StaticQuery
            query={graphql`
                query {
                    allMarkdownRemark(filter: {frontmatter: {type: {eq: "open-day"}}}, sort: {fields: frontmatter___date}) {
                        nodes {
                            html
                            frontmatter {
                                title
                                date(formatString: "DD MMMM YYYY")
                            }
                        }
                    }
                }
            `}
            render={data => (
                data.allMarkdownRemark.nodes.map((node, index) => {
                    return (
                        <div key={index}>
                            <h2>{node.frontmatter.title}</h2>
                            <p>{node.frontmatter.date}</p>
                            <div className="blog-post-content" dangerouslySetInnerHTML={{ __html: node.html }} />
                        </div>
                    );
                })
            )}
        />
    )
}